<template>
    <div class="pt-[32px] pb-[56px]">
        <div class="font-bold text-emphas text-[30px] leading-[46px]">{{ $t("Feedback") }}</div>
        <div class="text-[16px] leading-[32px]">{{ $t("FeedbackDesc") }}</div>
        <div class="mt-[8px] px-[24px] py-[16px] bg-color7">
            <table class="border-collapse">
                <tbody>
                    <tr>
                        <td class="pr-[8px]">{{ useColon($t("Phone")) }}</td>
                        <td class="font-bold text-emphas">18028568424</td>
                    </tr>
                    <tr>
                        <td class="pr-[8px]">{{ useColon($t("Email")) }}</td>
                        <td class="font-bold text-emphas">rddc-support@tsinghua-gd.org</td>
                    </tr>
                    <tr>
                        <td class="pr-[8px]">{{ useColon($t("Website")) }}</td>
                        <td class="font-bold text-emphas">rddc.tsinghua-gd.org</td>
                    </tr>
                    <tr>
                        <td class="pr-[8px]">{{ useColon($t("Address")) }}</td>
                        <td class="font-bold text-emphas">No.98, Xiangxue Road, Huangpu District, Guangzhou City</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-[32px] mb-[8px] font-bold text-emphas text-[16px] leading-[32px]">{{ $t("YourSuggestionOrInquiry") }}:</div>
        <ui-textarea
            v-model="input"
            class="text-emphas"
            style="--uioption-textarea-spacing-x: 24px; --uioption-form-radius: 0; --uioption-form-font-color: var(--uicolor-font-1)"
            :height="272"
            :placeholder="$t('PleaseEnterYourSuggestionOrInquiry')"
            :maxlength="500">
        </ui-textarea>
        <ui-button class="mt-[16px]" :width="120" :disabled="!input.trim()" @click="methods.submit">{{ $t("Submit") }}</ui-button>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTextarea, UiButton, $message, $loading } from "various-ui";

//* 插件
const i18n = useI18n();
//* 输入框
const input = ref<string>("");

//* 函数
const methods = {
    //* 提交
    submit: () => {
        $loading.open({ delay: 200, message: "" });
        const keyword = input.value.trim();
        input.value = "";
        api.frontend("/user/feedback", {
            headers: { "X-Token": useCookie("X-Token").value || "" },
            method: "POST",
            data: { feedback: keyword },
            finally: () => $loading.close(),
            success: () => {
                $message.success(i18n.t("ContactUs.Success"));
            },
        });
    },
};
</script>
